export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.9.8-1955.28",
  commitId: "623c8f23601c35bd69627d29494ad622d3602585",
  commitTime: "2026-09-08T19:55:28.000Z",
});
